/**
 * Arma el `src` y el `srcset` de las imágenes optimizadas.
 *
 * Los archivos los genera `scripts/optimize-assets.js` con el patrón
 * `<base>-<ancho>.webp` dentro de `static/assets/`, que Gatsby publica en la
 * raíz. Así el browser baja solo el ancho que necesita.
 */
export const responsiveImage = (base, widths) => ({
	src: `${base}-${widths[widths.length - 1]}.webp`,
	srcSet: widths.map((width) => `${base}-${width}.webp ${width}w`).join(", ")
});

/** Anchos disponibles por tipo de recurso (ver scripts/optimize-assets.js). */
export const PHOTO_WIDTHS = [640, 960, 1280, 1920];
export const CARD_WIDTHS = [480, 800, 1200, 1600];
export const SIDE_WIDTHS = [640, 960, 1280];

export default responsiveImage;
